import { Box, styled } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

export const PanelRoot = styled(Box)(({ theme }) => {
  const line = getThemeColor(theme, MUIThemeColors.secondaryLight)
  return {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    borderTop: `1px solid ${line}`,
    backgroundColor: getThemeColor(theme, MUIThemeColors.white),
    [theme.breakpoints.up('md')]: { borderTop: 'none', borderLeft: `1px solid ${line}` },
  }
})

// Holds a section above the panel: scrolling moves it out of view and leaves the panel at its usual full height.
export const PanelShell = styled(Box)(({ theme }) => {
  const line = getThemeColor(theme, MUIThemeColors.secondaryLight)
  return {
    minHeight: 0,
    overflowY: 'auto',
    backgroundColor: getThemeColor(theme, MUIThemeColors.white),
    borderTop: `1px solid ${line}`,
    [theme.breakpoints.up('md')]: { borderTop: 'none', borderLeft: `1px solid ${line}` },
  }
})

export const PanelScrollArea = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflow: 'auto',
  padding: theme.spacing(1.75, 2.5),
}))

export const PanelBand = styled(Box, { shouldForwardProp: prop => prop !== 'dividerEdge' })<{
  dividerEdge: 'top' | 'bottom'
}>(({ theme, dividerEdge }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.25),
  padding: dividerEdge === 'bottom' ? theme.spacing(2, 2.5, 1.75) : theme.spacing(1.5, 2.5, 2),
  [dividerEdge === 'bottom' ? 'borderBottom' : 'borderTop']: `1px solid ${getThemeColor(
    theme,
    MUIThemeColors.secondaryLight,
  )}`,
}))

export const EmptyNote = styled(Box)(({ theme }) => ({
  fontSize: 12.5,
  fontWeight: 500,
  color: getThemeColor(theme, MUIThemeColors.secondaryDark),
  backgroundColor: getThemeColor(theme, MUIThemeColors.backgroundMain),
  borderRadius: 6,
  padding: theme.spacing(1.5),
}))
